import React, { Component } from 'react';
import PropTypes from 'prop-types';

let Map = null;
let CircleMarker, TileLayer,Marker, Polyline;

class MapWrapper extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      bounds: []
    }
  }

  comoponenWillUnmount(){
  }

  componentDidMount(){
    //Only runs on Client, not on server render
    Map = require('react-leaflet').Map;
    TileLayer = require('react-leaflet').TileLayer;
    Marker = require('react-leaflet').Marker;
    CircleMarker = require('react-leaflet').CircleMarker;
    Polyline = require('react-leaflet').Polyline;
    this.forceUpdate();
  }

  fitBounds(routePath,eventsIcons) {
    var left,right,top,bottom;

    if(routePath.length>1) {
      for(var i=0;i<routePath.length;i++) {
        var point = routePath[i];
        if(i==0){
          left = point[1];
          right = point[1];
          top = point[0];
          bottom = point[0];
        }
        left = Math.min(left,point[1]);
        right = Math.max(right,point[1]);
        top = Math.max(top,point[0]);
        bottom = Math.min(bottom,point[0]);
      }
      this.state.bounds = [
        [bottom,left],
        [top,right]
      ]; 
    }
    else if(routePath.length<=1 && eventsIcons.length>=1) {
      for(var i=0;i<eventsIcons.length;i++) {
        var point = eventsIcons[i].point;        
        if(i==0) {
          this.state.bounds.push([point[0],point[1]-0.006125]);
          this.state.bounds.push([point[0],point[1]+0.006125]);
        }
        this.state.bounds.push(point);
      }    
    }
    else {
      this.state.bounds = [
        [0,0],
        [0,0.1]
      ];       
    }    
  }

  componentWillUpdate(nextProps,nextState) {
    this.fitBounds(nextProps.routePath,nextProps.eventsIcons);
  }

  componentWillMount() {
    this.fitBounds(this.props.routePath,this.props.eventsIcons);
  }

  render() {
    if(Map==null 
      || (this.props.routePath.length<=1 && this.props.eventsIcons.length==0)
      || this.state.bounds.length==0) {
      return (<div></div>);
    }
    var fromIcon = L.divIcon({
        html: 'A',
        className: 'map-indicator',
        iconSize: [20,32],
        iconAnchor: [0,0]
    });
    var toIcon = L.divIcon({
        html: 'B',
        className: 'map-indicator',
        iconSize: [20,32],
        iconAnchor: [0,0]
    });
    return (
      <Map 
        center={[0, 0]} 
        ref='leaflet-map'
        bounds={this.state.bounds}
        boundsOptions={{padding: [32, 32]}} 
        style={{height:"100%",width:"100%",overflow: "hidden"}}
      >
        <TileLayer
          url='https://{s}.tile.osm.org/{z}/{x}/{y}.png'
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />
        {this.props.routePath.length>1 && 
          <Polyline 
            positions={this.props.routePath}
            color="#EF811D"
            weight={7}
            opacity={0.9}
          />
        }
        {this.props.routePath.length>1 && 
          <Marker 
            position={this.props.routePath[0]}
            icon={fromIcon}
            pane="tooltipPane">
          </Marker>
        }
        {this.props.routePath.length>1 && 
          <Marker 
            position={this.props.routePath[this.props.routePath.length-1]}
            icon={toIcon}
            pane="tooltipPane">
          </Marker>
        }
        {this.props.eventPolylines.map(function(obj,index){
          return (
            <Polyline 
              key={index}
              positions={obj.path}
              color={obj.color}
              weight={7}
              opacity={0.9}
              pane="shadowPane"
            />
          );
        })}
        {this.props.eventsIcons.map(function(obj,index){
          return (
            <CircleMarker 
              key={index}
              center={obj.point}
              radius={8}
              color="#FFF"
              weight={1}
              fillColor={obj.color}
              fillOpacity={0.9}
              opacity={0.9}
              pane="markerPane"
            />
          );
        })}
      </Map>
    );
  }
}

MapWrapper.propTypes = {
  routePath: PropTypes.array.isRequired,
  eventPolylines: PropTypes.any,
  eventsIcons: PropTypes.any
};

export default MapWrapper;


// WEBPACK FOOTER //
// ./source/client/components/common/graphs/crossfilterGraphs/util/mapWrapper.jsx